module.exports = __webpack_public_path__ + "img/IT0000842686899.afba5ceb.png";